var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkiing40PxSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "skiing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 55,
    r: 3,
    fill: "#FF2E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,48,34.142,33.521a19.531,19.531,0,0,0,5.474-10.054,19.315,19.315,0,0,0-1.138-11.345,19.725,19.725,0,0,0-7.367-8.813,20.309,20.309,0,0,0-22.222,0,19.725,19.725,0,0,0-7.367,8.813A19.315,19.315,0,0,0,.384,23.467,19.531,19.531,0,0,0,5.858,33.521Z",
    fill: "#FF2E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.5,12.5)",
    fill: "#ffffff",
    d: "M15,4.5C15,5.3284,14.3284,6,13.5,6S12,5.3284,12,4.5S12.6716,3,13.5,3S15,3.6716,15,4.5z M13.72,11.89 c-0.0623-0.1197-0.2083-0.1684-0.33-0.11c-0.6846,0.4194-1.5208,0.5111-2.28,0.25L4.78,8.86L7.5,7.5v-3L9,5.25v3L10.5,9L12,8.25 L10.5,7.5V3l-3-1.5L6,2.25v4.5L3.28,8.11L0.61,6.78C0.4857,6.7192,0.3358,6.7707,0.275,6.895C0.2142,7.0193,0.2657,7.1692,0.39,7.23 l10.5,5.25c0.3156,0.135,0.6568,0.1998,1,0.19c0.5998-0.0103,1.1889-0.161,1.72-0.44c0.1236-0.0615,0.174-0.2116,0.1125-0.3352 C13.7217,11.8932,13.7208,11.8916,13.72,11.89z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiing40PxSelected);
export default __webpack_public_path__ + "static/media/skiing_40px_selected.2c4bc7819079f9b4b8576952aeab5b30.svg";
export { ForwardRef as ReactComponent };